import { render, staticRenderFns } from "./CenterContent.vue?vue&type=template&id=d231a7f0&"
import script from "./CenterContent.vue?vue&type=script&lang=js&"
export * from "./CenterContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports